import api from "app/lib/api";
import endpoints from "static/endpoints";

export const getAccounts = async () => {
  const { data } = await api.get(endpoints.dashboard.accounts);
  return data;
};
